export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

export const api = {
  get: (path, token) => fetch(`${API_BASE}/api${path}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then((r) => {
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json();
  }),
  post: (path, body, token) => fetch(`${API_BASE}/api${path}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Une erreur est survenue");
    return data;
  }),
  put: (path, body, token) => fetch(`${API_BASE}/api${path}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify(body),
  }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Une erreur est survenue");
    return data;
  }),
  del: (path, token) => fetch(`${API_BASE}/api${path}`, {
    method: "DELETE",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }).then(async (r) => {
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Une erreur est survenue");
    return data;
  }),
};

export const COUNTRIES = [
  { code: "FR", name: "France" },
  { code: "BE", name: "Belgique" },
  { code: "DE", name: "Allemagne" },
  { code: "ES", name: "Espagne" },
  { code: "IT", name: "Italie" },
  { code: "NL", name: "Pays-Bas" },
  { code: "PT", name: "Portugal" },
  { code: "LU", name: "Luxembourg" },
  { code: "AT", name: "Autriche" },
  { code: "IE", name: "Irlande" },
  { code: "DK", name: "Danemark" },
  { code: "SE", name: "Suède" },
  { code: "FI", name: "Finlande" },
  { code: "PL", name: "Pologne" },
  { code: "CZ", name: "Tchéquie" },
  { code: "GR", name: "Grèce" },
  { code: "CH", name: "Suisse" },
  { code: "GB", name: "Royaume-Uni" },
  { code: "US", name: "États-Unis" },
  { code: "CA", name: "Canada" },
  { code: "MA", name: "Maroc" },
  { code: "DZ", name: "Algérie" },
  { code: "TN", name: "Tunisie" },
  { code: "SN", name: "Sénégal" },
  { code: "CI", name: "Côte d'Ivoire" },
  { code: "CM", name: "Cameroun" },
  { code: "AE", name: "Émirats arabes unis" },
  { code: "XX", name: "Autre pays" },
];

export const EU_CODES = new Set([
  "FR", "BE", "DE", "ES", "IT", "NL", "PT", "LU", "AT", "IE", "DK", "FI",
  "SE", "PL", "CZ", "HU", "RO", "GR", "HR", "SI", "SK", "BG", "EE", "LV",
  "LT", "CY", "MT",
]);

export function zoneOf(code) {
  if (code === "FR") return "france";
  if (EU_CODES.has(code)) return "europe";
  return "international";
}

export function formatEUR(n) {
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(n);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Une erreur est survenue. Réessayez.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
